import React, { useState } from 'react';
import Carousel from 'react-bootstrap/Carousel';
import './HeroSection.css';

import bannerImg from '../assets/banner.jpeg';
import bannerImg1 from '../assets/banner-1.jpeg';
import bannerImg2 from '../assets/banner-2.jpeg';
import bannerImg3 from '../assets/banner-3.jpeg';
import bannerImg4 from '../assets/banner-4.jpeg';

const images = [
  bannerImg,
  bannerImg1,
  bannerImg2,
  bannerImg3,
  bannerImg4,
];

function HeroSection() {
  const [loadedImages, setLoadedImages] = useState(Array(images.length).fill(false));

  const handleImageLoad = (index) => {
    const updated = [...loadedImages];
    updated[index] = true;
    setLoadedImages(updated);
  };

  return (
    <div className="hero-carousel-container">
      <div className="carousel-overlay enhanced-welcome">
        <h2 className="welcome-title animate__animated animate__fadeInUp">
          Welcome to <br />
          <span className="temple-name">Sri Sri Radha Madan Mohan Temple</span>
        </h2>
        <p className="welcome-subtitle animate__animated animate__fadeInUp animate__delay-1s">
          Founder-Acharya: <br />
          His Divine Grace A. C. Bhaktivedanta Swami Prabhupada
        </p>
      </div>

      <Carousel fade controls={false} indicators interval={5000} pause={false}>
        {images.map((img, index) => (
          <Carousel.Item key={index}>
            <div className="carousel-image-wrapper">
               <img
                src={img}
                alt={`Banner ${index + 1}`}
                className={`carousel-image ${loadedImages[index] ? 'visible' : 'hidden'}`}
                loading="lazy"
                onLoad={() => handleImageLoad(index)}
              />
            </div>
          </Carousel.Item>
        ))}
      </Carousel>
    </div>
  );
}

export default HeroSection;
